export default {
  LIST_FETCHED: 'CATEGORIES_TEMPLATES_FETCHED',
  LIST_TYPE_FETCHED: 'CATEGORIES_TYPES_TEMPLATES_FETCHED',
  LIST_LOAD: 'CATEGORIES_TEMPLATES_LOAD',
  ITEM_DETAIL: 'CATEGORIES_TEMPLATES_DETAIL',
  BUTTON_LOAD: 'CATEGORIES_TEMPLATES_BUTTON_LOAD',
};
